import { Box, Checkbox, FormControlLabel, Stack } from "@mui/material";
import * as React from "react";
import { UserGroupType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { IUnitNode, UnitNode } from "../../../../../models/unit/unitNode";
import { IUnitSummaryNode, UnitSummaryNode } from "../../../../../models/unit/unitSummaryNode";
import { IUnitPermissionUserGroup, UnitPermissionUserGroup } from "../../../../../models/userGroup/unitPermissionUserGroup";
import { ActionContainer } from "../../../../framework/ActionContainer";
import { Dialog } from "../../../../framework/Dialog/Dialog";
import { ListSearchFilter } from "../../../../framework/List/ListSearchFilter";
import { UnitApplicationPermissions } from "source/components/framework/Unit/UnitApplicationPermissions";
import { TUnitPermission } from "source/models/unit/unitPermission";
import { UnitPermissionSummaryTableNew } from "../UnitPermissionSummaryTableNew";

export interface IUnitPermissionSummaryDialogNewProp {
    classes?: string;
    groups: IUnitPermissionUserGroup[];
    hideAllUsers?: boolean;
    hideUserGroups?: boolean;
    unitNode: IUnitNode;
    unitPermissions: TUnitPermission[];
    onCancel: () => void;
}

export interface IUnitPermissionSummaryDialogNewState {
    summaryNode: IUnitSummaryNode;
    showInheritedPermissions: boolean;
    showUserGroups: boolean;
    showUsers: boolean;
    filter: string;
}

export class UnitPermissionSummaryDialogNew extends React.Component<IUnitPermissionSummaryDialogNewProp, IUnitPermissionSummaryDialogNewState> {
    getBaseUnitSummaryNode = (unitNode: IUnitNode): UnitSummaryNode => {
        const result = new UnitSummaryNode();
        result.id = unitNode.id;
        result.name = unitNode.name;
        for (const child of unitNode.children) {
            result.children.push(this.getBaseUnitSummaryNode(child));
        }
        return result;
    };

    getUnitSummaryNode = (unitNode: IUnitNode, userGroups: IUnitPermissionUserGroup[]): UnitSummaryNode => {
        const result = this.getBaseUnitSummaryNode(unitNode);
        for (const userGroup of userGroups) {
            const userGroupUnitNode = new UnitNode(unitNode);
            userGroupUnitNode.setEffectivePermissions(null, userGroup);
            result.setUserGroupPermissions(userGroup, userGroupUnitNode);
        }
        return result;
    };

    constructor(props: IUnitPermissionSummaryDialogNewProp) {
        super(props);
        this.state = {
            summaryNode: null,
            showInheritedPermissions: false,
            showUserGroups: true,
            showUsers: true,
            filter: ""
        };
    }

    componentDidMount(): void {
        const props = this.props;
        const groups = props.groups.map(i => new UnitPermissionUserGroup(i));
        const userGroups: IUnitPermissionUserGroup[] = (!props.hideAllUsers ? UnitApplicationPermissions.getUserGroups(groups, true, UserGroupType.Normal) : [])
            .concat(!props.hideUserGroups ? UnitApplicationPermissions.getUserGroups(groups, false, UserGroupType.Normal) : [])
            .concat(UnitApplicationPermissions.getUserGroups(groups, false, UserGroupType.Fixed));
        this.setState({
            summaryNode: this.getUnitSummaryNode(props.unitNode, userGroups)
        });
    }

    render() {
        const props = this.props;
        const state = this.state;
        if (!state.summaryNode) return null;
        return (
            <Dialog
                id="unit-permission-summary-dialog"
                maxWidth="md"
                title={Translations.SetPermissions}
                centerOnResize
                body={
                    <Box sx={{ margin: "-1rem 0" }}>
                        <Stack direction="row" justifyContent="space-between">
                            <FormControlLabel
                                label={Translations.ShowInheritedPermissions}
                                control={
                                    <Checkbox
                                        checked={state.showInheritedPermissions}
                                        onChange={(_e, checked: boolean) => {
                                            this.setState({ showInheritedPermissions: checked });
                                        }}
                                    />
                                }
                                sx={{ marginBottom: ".5rem" }}
                            />
                            {!props.hideUserGroups &&
                                <FormControlLabel
                                    label={Translations.ShowUserGroups}
                                    control={
                                        <Checkbox
                                            checked={state.showUserGroups}
                                            onChange={(_e, checked: boolean) => {
                                                this.setState({ showUserGroups: checked });
                                            }}
                                        />
                                    }
                                />
                            }
                            {!props.hideUserGroups && !props.hideAllUsers &&
                                <FormControlLabel
                                    label={Translations.ShowUsers}
                                    control={
                                        <Checkbox
                                            checked={state.showUsers}
                                            onChange={(_e, checked: boolean) => {
                                                this.setState({ showUsers: checked });
                                            }}
                                        />
                                    }
                                />
                            }
                        </Stack>
                        <ActionContainer leftItems={
                            <ListSearchFilter
                                inline={true}
                                active={!!state.filter}
                                searchFilter={state.filter}
                                onSearchClick={(filter: string) => this.setState({ filter })}
                            />
                        } />
                        <Box sx={{ maxHeight: "calc(100vh - 400px)", overflowY: "auto", marginRight: "-1.5rem", paddingRight: "1rem" }}>
                            <UnitPermissionSummaryTableNew
                                unitNode={state.summaryNode}
                                parentName={""}
                                unitPermissions={props.unitPermissions}
                                showInheritedPermissions={state.showInheritedPermissions}
                                showUserGroups={state.showUserGroups}
                                showUsers={state.showUsers}
                                filter={state.filter}
                            />
                        </Box>
                    </Box>
                }
                buttons={[
                    { title: Translations.Close, variant: "outlined", onClick: props.onCancel }
                ]}
                onClose={props.onCancel}
            />
        );
    }
}